import { render, staticRenderFns } from "./ServiceAgreementCN.vue?vue&type=template&id=2e8bad14&scoped=true&"
import script from "./ServiceAgreementCN.vue?vue&type=script&lang=js&"
export * from "./ServiceAgreementCN.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAgreementCN.vue?vue&type=style&index=0&id=2e8bad14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8bad14",
  null
  
)

export default component.exports